// extracted by mini-css-extract-plugin
module.exports = {"label":"_1JzxkGQTNo7BhEucK0xSQ4","active":"_32l-W08vuuHOtAjqtsOKM3"};